import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AiFillCheckCircle, AiFillInfoCircle } from 'react-icons/ai';
import { useMemo } from 'react';

function ToolTip({ warnings, isComplete }) {
  const isOk = useMemo(() => isComplete, [isComplete]);
  let msgs = {};

  try {
    if (warnings != null || warnings != undefined) {
      let msgParse;
      if (typeof warnings === 'string') {
        msgParse = JSON.parse(warnings);
      }
      msgs = msgParse;
    }
  } catch (err) {
    console.log(err);
  }

  return (
    <OverlayTrigger
      placement="top-right"
      delay={{ show: 250, hide: 400 }}
      overlay={
        <Tooltip id="button-tooltip">
          <div>
            {isOk ? (
              <>
                Profile is <b>Complete</b> !
              </>
            ) : (
              msgs &&
              Object.entries(msgs).map(([key, value]) => {
                return (
                  <span key={key} className="d-block">
                    <b> {key.replaceAll('_', ' ')} </b> : {value}
                  </span>
                );
              })
            )}
          </div>
        </Tooltip>
      }>
      <span>
        {isOk ? (
          <AiFillCheckCircle className="text-success" />
        ) : (
          <AiFillInfoCircle className="text-warning" />
        )}
      </span>
    </OverlayTrigger>
  );
}

export default ToolTip;
